import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// [robot] 用户结束使用
export async function submitRepeatAnswer(params) {
  const url = `/cognition/repeat/submitAnswer`;
  return await _request({
    method: 'POST',
    url,
    data: params
  });
}

// [robot] 获取总体训练结果
export async function getRepeatGrade() {
  const url = `/cognition/repeat/getGrade`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] 获取历史训练数据
export async function getRepeatPageTrain() {
  const url = `/cognition/repeat/pageTraining`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] 用户结束使用
export async function submitCLassifyAnswer(params) {
  const url = `/cognition/classify/submitAnswer`;
  return await _request({
    method: 'POST',
    url,
    data: params
  });
}

// [robot] 获取总体训练结果
export async function getCLassifyGrade() {
  const url = `/cognition/classify/getGrade`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] 获取历史训练数据
export async function getClassifyPageTrain() {
  const url = `/cognition/classify/pageTraining`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] 获取训练数据
export async function getClassifyTrain() {
  const url = `/cognition/repeat/getTraining`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] 根据deviceId 查询配置
export async function getConfigByDeviceId(params) {
  const url = `/robot/getConfigByDevice${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  })
}

// [robot] 机器人登录或注册
export async function loginByRobot(data) {
  const url = `/robot/autoRegisterLogin`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// [robot] 机器人账号密码登录
export async function loginByRobotWithAccount(data) {
  const url = `/robot/loginByAccount`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// robot-ai 老人陪伴助手结束上传接口
export async function finishTalk(userId, sessionId) {
  const url = `/ai/old/finishTalk/${userId}/${sessionId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

// [robot] 用户结束使用
export async function AIUseEnd() {
  const url = `/ai/useEnd`;
  return await _request({
    method: 'POST',
    url,
  });
}

// [robot] AI测评结束
export async function AITestUseEnd(sessionId) {
  const url = `/ai/useEnd/${sessionId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

// [robot] 获取AI结论
export async function getAIConsultationSummary(id) {
  const url = `/ai/consultationSummary/${id}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [robot] AI创建TASK
export async function AICreateTask(data) {
  const url = `/robot/task/create`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// [robot] 任务结束
export async function AIFinishTask(taskId) {
  const url = `/robot/task/finish/${taskId}`;
  return await _request({
    method: 'POST',
    url
  });
}

export async function getPreviousSessions(consultantId, pageNo, pageSize) {
  const url = `/ai/chat/sessions?consultantId=${consultantId}&pageNo=${pageNo}&pageSize=${pageSize}`;
  return await _request({
    method: 'GET',
    url,
  });
}

export async function aiChatTalk(data) {
  const url = `/ai/chat/talks`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

export async function aiCloseSession(sessionId) {
  const url = `/ai/closeSession/${sessionId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

export async function aiOpenSession(params, cardRoundId) {
  const url = `/ai/openSession${_getQuerystr(params)}`;
  return await _request({
    method: 'POST',
    url,
    ...(cardRoundId ? { data: { cardRoundId } } : {}),
  });
}

export async function getChatMessages({ sessionId, limit, offset }) {
  const url = `/ai/chat/messages?sessionId=${sessionId}&limit=${limit}&offset=${offset}`;
  return await _request({
    method: 'GET',
    url,
  });
}


export async function getSuggestion(suggestionId) {
  const url = `/ai/suggestion/${suggestionId}`;
  return await _request({
    method: 'GET',
    url,
  });
}

export async function playSuggestion(suggestionId) {
  const url = `/ai/suggestion/play/${suggestionId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

export async function completeSuggestion(suggestionId) {
  const url = `/ai/suggestion/complete/${suggestionId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

export async function getTrajectory(sessionId, chatMsgId) {
  const url = `/trajectories/${sessionId}/${chatMsgId}`;
  return await _request({
    method: 'GET',
    url,
  });
}

